export const nextI18NextConfig = {
  i18n: {
    locales: ["en", "fr"],
    defaultLocale: "en",
  },
};
